<template>
<!-- 头部公用部分 -->
 <div>

     <!-- 审核不通过理由模态框 -->
      <Modal
        v-model="reason.reasonModel"
        title="审核不通过理由"
        width="400"
        :footerHide="true"
        >
         <Form  :label-width="90">
            <FormItem class="suspendCause" label="不通过原因：">
                <Input v-model="auditUnPassReason" placeholder="请填写原因" type="textarea"></Input>
            </FormItem>
            <div class="UpBut">
                <Button class="m-r10px" type="primary" size="large"    @click="reasonEditOk()">提交</Button>
            </div>
        </Form>
    </Modal>
   
 </div>
</template>

<script>
  export default {
    props: ['reason'],
    data() {
      return {
        auditUnPassReason:''
      }
    },
    methods:{
      reasonEditOk()
      {
        this.$emit('reasonFormSubmit',this.auditUnPassReason);
      }
    },
    mounted(){
    }
  }
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/public/auditReason.vue